/**
 * 用于 react-router 的路由 path
 */
export const routeUrls = Object.freeze({
  bill: "/bill",
  fee: "/fee",
  feeEntry: "entry",
  feeOrder: "order/:meterNo",
  feeOrderChannel: "order/:orderNo/channel",
  feePaymentDetail: "payments/:orderNo",
  feePayments: "payments",
  feePayResult: "/fee/payResult/:orderNo",
  feeTenPay: "/fee/tenPay",
  home: "/",
  login: "/login",
  loginWechat: "/login/wechat",
  me: "/me",
  meBindMeter: "/me/meters/binding",
  meBindEBMS: "/me/EBMS/binding",
  meMessage: "/me/message",
  meMeters: "/me/meters",
  meProfile: "/me/profile",
  meSupport: "/me/support",
  requireAuthWild: "/*",
  eas: Object.freeze({
    powerLimitBinding: "/eas/user/powerlimit/:corpId"
  })
});

/**
 * 用于跳转的 urls
 */
export const urls = Object.freeze({
  bill: () => "/bill",
  bindMeter: () => "/me/meters/binding",
  bindEBMS: () => routeUrls.meBindEBMS,
  fee: () => "/fee",
  feeEntry: () => "/fee/entry",
  home: () => "/",
  login: () => "/login",
  loginWechat: () => routeUrls.loginWechat,
  me: () => "/me",
  message: () => "/me/message",
  meters: () => "/me/meters",
  paymentDetail: (orderNo) => `/fee/payments/${orderNo}`,
  payments: () => "/fee/payments",
  payResult: (orderNo) => `/fee/payResult/${orderNo}`, 
  profile: () => "/me/profile",
  recharge: (meterNo) => `/fee/order/${meterNo}`,
  rechargeChannel: (orderNo) => `/fee/order/${orderNo}/channel`,
  support: () => "/me/support",
  surchargeJs: () => "/js/Surcharge.js",
  tenPay: () => routeUrls.feeTenPay
});
